import { Button } from "@components/index";
import Clock from "assets/svg/clock.svg";
import SideArrow from "assets/svg/leftArrow.svg";
import Profile from "assets/svg/newCourses/profile.svg";
import Link from "next/link";
import React, { useState } from "react";
import { convertToJalali } from "src/utils";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { Title } from "..";

function FreeCourses({ data }: { data: any }): JSX.Element {
  // const [swiperRef, setSwiperRef]: any = useState();

  // const [slidePosition, setSlidePosition] = useState({
  //   isEnd: false,
  //   isBeginning: true,
  // });
  const getCourseTypeName = (type: number) => {
    switch (type) {
      case 0:
        return "حضوری";
      case 1:
        return "آنلاین";
      case 2:
        return "آفلاین";
    }
  };

  return (
    <div className="z-10 flex h-auto w-full flex-col pr-[10%] md:px-[10%]">
      <div className="mb-4 flex w-full items-center justify-between md:mb-9">
        <div className="">
          <Title
            title="رایگان آموزش ببین"
            hideLinesOnResponsive="hidden md:flex"
          />
        </div>
        <div className="grid items-center gap-x-5 pl-[10%] text-blue md:pl-0 lg:grid-cols-3">
          <Link href={"/search?types=free"}>
            <a>
              <span className="cursor-pointer">همه</span>
            </a>
          </Link>
          <SideArrow
            className={`swiper-button-prev-free-course hidden rotate-180 cursor-pointer fill-[#0577AF] lg:block`}
          />
          <SideArrow
            className={`swiper-button-next-free-course hidden cursor-pointer fill-[#0577AF] lg:block`}
          />
        </div>
      </div>
      <div className="relative h-auto text-white">
        <Swiper
          // onSlideChange={(e) =>
          //   setSlidePosition({ isBeginning: e.isBeginning, isEnd: e.isEnd })
          // }
          className="flex justify-center"
          // onSwiper={(e) => {
          // setSwiperRef(e);
          // setSlidePosition({
          //   isBeginning: e?.isBeginning,
          //   isEnd: swiperRef?.isEnd,
          // });
          // }}
          navigation={{
            nextEl: ".swiper-button-next-free-course",
            prevEl: ".swiper-button-prev-free-course",
          }}
          modules={[Navigation]}
          // onBeforeLoopFix={(e) =>
          //   setSlidePosition({ isBeginning: e.isBeginning, isEnd: e.isEnd })
          // }
          breakpoints={{
            359: {
              slidesPerView: 1.1,
              spaceBetween: 5,
            },
            767: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          }}
        >
          {data?.map((item: any) => (
            <SwiperSlide
              key={JSON.stringify(item?.id)}
              className="flex cursor-pointer justify-center"
            >
              <Link
                href={{
                  href: `/course/${item?.id}`,
                  pathname: item?.seoUrlDescription
                    ? `/course/${item?.id}/${encodeURIComponent(
                        item?.seoUrlDescription
                      )}`
                    : `/course/${item?.id}`,
                }}
              >
                <a className="w-full">
                  <div
                    // onClick={() =>
                    //     router.push(`/course/${item?.id}`, {
                    //         pathname: item?.seoUrlDescription
                    //             ? `/course/${item?.id}/${encodeURIComponent(
                    //                   item?.seoUrlDescription,
                    //               )}`
                    //             : `/course/${item?.id}`,
                    //     })
                    // }
                    style={{
                      contain: "content",
                      borderColor: "#0577AF",
                    }}
                    className="relative flex h-[380px] w-full flex-col rounded-lg border-b-2 shadow"
                  >
                    <div className="flex h-[45%] w-full items-center justify-between">
                      <img
                        loading="lazy"
                        src={item?.image}
                        className="h-full w-full"
                        alt="laptop 666"
                      />
                    </div>
                    <div className="relative z-10 flex h-full flex-col justify-between text-white">
                      <div className="px-3 pt-7 pb-4 text-sm sm:px-3">
                        <p className="ellipsis-line ellipsis-line-clamp-2 text-[15px]">
                          {item?.name}
                        </p>
                        <div className="mt-7 space-y-3 text-xs">
                          <div className="flex">
                            <Clock className="ml-2 fill-white" />
                            <p>
                              {item?.startDate
                                ? convertToJalali(item?.startDate)
                                : convertToJalali(item?.releaseDatetime)}

                              {item?.hour && `- ${item?.hour}`}
                            </p>
                          </div>
                          {item?.teacherNames && (
                            <div className="flex">
                              <Profile className="ml-2 w-[16px] fill-white" />
                              <p className="ellipsis-line ellipsis-line-clamp-1 flex-1 text-justify">
                                {item?.teacherNames} ـ{" "}
                                {getCourseTypeName(item?.courseType)}
                              </p>
                            </div>
                          )}{" "}
                        </div>
                      </div>
                      <div className="flex w-full items-center justify-between px-3 pb-2">
                        <div className="whitespace-nowrap text-base">
                          رایگان
                        </div>
                        <Button
                          // isLoading={isLoading}
                          // onClick={(e) => {
                          //     e.stopPropagation();
                          //     handlePay({ discount, price, id });
                          // }}
                          className="rounded-lg bg-white py-2 px-3 text-blue sm:px-4"
                        >
                          افزودن به داشبورد
                        </Button>
                      </div>
                    </div>
                    <div
                      style={{
                        clipPath: "polygon(0 34%, 100% 23%, 100% 100%, 0 100%)",
                        background:
                          "linear-gradient(180deg, #0577AF 7.29%, #046696 100%)",
                      }}
                      className="absolute -bottom-5 right-0 flex h-[100%] w-full flex-col justify-between pb-5"
                    />
                  </div>
                </a>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default FreeCourses;
